(function () {
  'use strict';

  function patchAppPanel(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('.trust-panels.nodia-section#scenes').forEach(function (section) {
      var firstPanel = section.querySelector('.trust-panels__grid .trust-panel');
      if (!firstPanel) return;

      var icon = firstPanel.querySelector('.trust-panel__icon');
      var label = firstPanel.querySelector('.trust-panel__label');
      var title = firstPanel.querySelector('.trust-panel__title');
      var body = firstPanel.querySelector('.trust-panel__body');
      var cta = firstPanel.querySelector('.trust-panel__cta');

      if (icon) {
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2.75" width="10" height="18.5" rx="2.5"></rect><path d="M10 6.5h4"></path><path d="M10 16h4"></path><circle cx="12" cy="19" r="0.9"></circle><path d="M18.75 8.25c1.35.45 2.25 1.28 2.25 2.25 0 1.43-1.94 2.59-4.33 2.59-.24 0-.47-.01-.69-.04"></path><path d="M5.25 8.25C3.9 8.7 3 9.53 3 10.5c0 1.43 1.94 2.59 4.33 2.59.24 0 .47-.01.69-.04"></path></svg>';
      }

      if (label) label.textContent = 'INTEREST COMMUNITY APP';
      if (title) title.textContent = 'Download the Nodia Community App';
      if (body) body.textContent = 'A social app built around interests, discovery, and meeting like-minded people — think of it as an international Xiaohongshu-style community. The app is currently in invite-only registration, so downloads and sign-ups are opening gradually through invitation codes.';
      if (cta) {
        cta.setAttribute('href', '/pages/contact');
        cta.innerHTML = 'GET INVITE ACCESS<span aria-hidden="true">→</span>';
      }

      firstPanel.classList.add('trust-panel--app');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchAppPanel(document);
    });
  } else {
    patchAppPanel(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    patchAppPanel(event.target);
  });
})();
